const initialState = {
  menuName: null,
  showPosMenu: false, // ini buat menu utama di bagian navigasi POS
  showPosAdd: false, // ini buat modal saat modal menu terbuka
  showPosEdit: false, // modal edit saat modal menu + detail terbuka
  showPosCart: false, // modal cart untuk tampilan cart di POS
  showPosDetail: false, // modal detail saat modal menu terbuka
  showPosAdditional: false, // modal additional saat modal edit terbuka
  showPosCompliment: false, // modal compliment saat modal edit terbuka
  showPosTable: false,
  targetId: null,
  data: null,
  rooms: [],
  tables: [],
  menus: [],
  orders: [],
  showPosOrder: null,
  showPosMeja: false,
};

const modalReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_POS_DATA":
      return {
        ...state,
        data: action.payload,
      };
    case "SET_POS_MENU":
      return {
        ...state,
        menuName: action.payload.target,
        showPosCart: false,
        showPosEdit: false,
        showPosAdd: false,
        showPosDetail: false,
        showPosAdditional: false,
        showPosCompliment: false,
        showPosMenu: action.payload.value,
      };
    case "SHOW_POS_ADD_MODAL":
      return {
        ...state,
        showPosAdd: action.payload,
        showPosEdit: false,
        showPosDetail: false,
        showPosAdditional: false,
        showPosCompliment: false,
        targetId: null,
      };
    case "SHOW_POS_EDIT_MODAL":
      // modal edit saat modal menu + detail terbuka -> lanjut pilihan compliment / delete / additional
      return {
        ...state,
        showPosAdd: false,
        showPosAdditional: false,
        showPosCompliment: false,
        showPosEdit: action.payload.edit,
        data: action.payload.data,
      };
    case "SHOW_POS_DETAIL_MODAL":
      // modal detail saat modal menu terbuka, buka menu -> detail -> lanjut pilihan edit
      return {
        ...state,
        showPosDetail: action.payload.detail,
        showPosAdditional: false,
        showPosCompliment: false,
        showPosEdit: false,
        showPosAdd: false,
        targetId: action.payload.id ?? null,
        data: null,
      };
    case "SHOW_POS_COMPLIMENT_MODAL":
      return {
        ...state,
        showPosCompliment: action.payload.compliment,
      };
    case "SHOW_POS_ADDITIONAL_MODAL":
      return {
        ...state,
        showPosAdditional: action.payload.additional,
      };

    case "SHOW_POS_CART_MODAL":
      return {
        ...state,
        showPosCart: action.payload.cart,
      };
    case "RESET_POS_MODAL":
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export default modalReducer;
